import * as React from 'react';
import {
  IControlError,
  IControlSchema,
  IControlSchemaBase,
} from '../../../core/Controls';
import { IDispatcher } from '../../helpers/Dispatcher';
import { SigCreatorFromFileDefault } from './components/SigCreatorFromFileDefault';
import { PdfResultCreator } from './components/PdfResultCreator';

export const createSigCreatorFromFile = (
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
  opts: any,
): React.ReactElement<any> => {
  const isWithoutSig = schema?.extra?.isWithoutSig;

  if (isWithoutSig)
    return (
      <PdfResultCreator
        schema={schema}
        api={api}
        dispatcher={dispatcher}
        error={error}
        visited={visited}
        opts={opts}
      />
    );

  return (
    <SigCreatorFromFileDefault
      schema={schema}
      api={api}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
      opts={opts}
    />
  );
};
